<nav class="header-container flex items-center h-56">
  <div class="flex justify-between items-center mx-16 w-full">
    <div class="flex items-center">
      <a href="#" class="brand-log flex items-center">
        <img src="../../../assets/images/kroger.svg" alt="The Kroger logo" />
      </a>
      <p-divider layout="vertical" class="vertical-divider"></p-divider>
      <div>
        <a class="text-default-50 nunito-regular-font heading-m font-700">
          Sales Tax Domain
        </a>
      </div>
    </div>
    <div
      *ngIf="loginDisplay"
      class="flex flex-row items-center navbar-nav ms-auto"
    >
      <a
        (click)="menu.toggle($event)"
        class="flex flex-row items-center text-default-50 text-default-50"
      >
        <img
          *ngIf="userImage; else ifNoImage"
          [src]="userImage"
          alt="user image"
          width="32"
          height="32"
          class="rounded-full"
        />
      </a>
      <p-menu
        #menu
        [popup]="true"
        [model]="loginMenuItems"
        class="log-in-out-menu"
      ></p-menu>
    </div>
  </div>
</nav>
<ng-template #ifNoImage>
  <kds-icon-account></kds-icon-account>
</ng-template>
